import { Role, User } from "../types";

export type RoleHandle =
    | "MANAGING_DIRECTOR"
    | "HR_ADMINISTRATION_OFFICER"
    | "BUSINESS_DEVELOPMENT_MANAGER"
    | "ADMINISTRATION_OFFICER";

export function hasRole(
    user: User | null | undefined,
    roles: RoleHandle[] | RoleHandle,
): boolean {
    if (!user) return false;

    // Super admin bypass

    if (user.is_admin) return true;
    if (user.is_super_admin) return true;

    const roleArray = Array.isArray(roles) ? roles : [roles];

    return (
        user?.roles?.some((role: Role) =>
            roleArray.includes(role.handle as RoleHandle),
        ) || false
    );
}
